module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lepus/lep_names-02edc9865c680a51c609eea37f7ccee3.gif";